
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/esm/Col';
import { useContext, useEffect, useState } from 'react';

//material-ui
import { isMemberOf, Loading } from '../common/variables';
import { AppContext } from '../context/app';
import { CoachContext } from '../context/coach';

export function Profile(){
  const { SetCoachProfile } = useContext(CoachContext);
  const { appState : {user : { groups} , userProfile}} = useContext(AppContext);
    const [loading , setLoading] = useState(true);
    useEffect(()=>{
      try{
        if(isMemberOf(groups , 'coach')){
          SetCoachProfile();
        }
        if(isMemberOf(groups , 'athlete')){
          
        }
      }
      finally{
        setTimeout(()=>setLoading(false) ,500);
      }
    },[]);
    return(
      <div className="mr-2 p-2">
        <div className="d-flex mb-1 justify-content-between">
            <h4>My Profile</h4>
        </div>
        {
          loading ? <Loading/> :
          <Form style={{ paddingTop : 10}}>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Profile Type</Form.Label>
                <Form.Control required type="text" placeholder="First name" defaultValue={'Coach'} readOnly/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Club Name</Form.Label>
                <Form.Control required type="text" placeholder="First name" defaultValue={userProfile.club.name} readOnly/>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>First Name</Form.Label>
                <Form.Control required type="text" placeholder="First name" defaultValue={userProfile.first_name}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Middle Name</Form.Label>
                <Form.Control type="text" placeholder="Middle name" defaultValue={userProfile.middle_name}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control required type="text" placeholder="Last name" defaultValue={userProfile.last_name}/>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label>Home Address</Form.Label>
                <Form.Control required type="text" placeholder="Home" defaultValue={userProfile.address}/>
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Parish</Form.Label>
                <Form.Control required type="text" placeholder="Parish" defaultValue={userProfile.parish}/>
              </Form.Group>
            </Form.Row>
            <Button>Update Profile</Button>
          </Form>
         }
    </div>)
  }